import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import * as fromCompanyInfoActions from '../store/company-info/company-info.actions';
import * as fromCompanyInfoReducer from '../store/company-info/company-info.reducer';
import { Advisor, CompanyInfo } from '../customer-admin.model';
import { Observable, of } from 'rxjs';
import { map, take, takeWhile } from 'rxjs/operators';
import clone from 'just-clone';
import * as fromAdvisorsActions from '../store/advisors/advisor.actions';
import * as fromAdvisorsReducer from '../store/advisors/advisor.reducer';
import * as fromShared from '../../shared';
import { IUserInfo } from '../../user-info';
import * as fromUser from '../../user-info/store';
import * as fromLookup from '../../lookups';
import * as fromAuth from '../../auth';
import * as fromAuthR from '../../auth/store/auth.reducer';
import * as fromRoot from '../../store';
@Component({
    selector: 'ef-customer-admin-feature',
    templateUrl: './customer-admin-feature.component.html',
    styleUrls: ['./customer-admin-feature.component.scss'],
    standalone: false
})
export class CustomerAdminFeatureComponent implements OnInit {
    process$: Observable<fromShared.Process>;
    items$: Observable<CompanyInfo[]>;
    advisors$: Observable<Advisor[]>;
    userInfo$: Observable<IUserInfo>;
    states$: Observable<Array<fromLookup.IState>>;
    auth$: Observable<fromAuth.State>;
    public version$: Observable<string>;
    showUpdateMessage = false;
    showUpdateFailedMessage = false;

    constructor(private store: Store) {}

    ngOnInit(): void {
        this.auth$ = this.store.pipe(select(fromAuthR.getAuth));
        this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));
        //this.version$ = this.store.pipe(select(fromRoot.Version.selectVersion));
        this.store.dispatch(fromAdvisorsActions.getAdvisor());
        this.setupObservables();
        this.setupSubscriptions();
    }
    setupObservables() {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.states$ = this.store.pipe(select(fromLookup.getStates));
        this.items$ = this.store.pipe(
            select(fromCompanyInfoReducer.selectAll),
            map(x => clone(x))
        );
        this.advisors$ = this.store.pipe(
            select(fromAdvisorsReducer.selectAll),
            map(z => clone(z))
        );
    }
    setupSubscriptions() {
        this.auth$.pipe(take(1)).subscribe(auth => {
            this.store.dispatch(
                fromCompanyInfoActions.getCompanyInfo({
                    customerid: auth.CustomerID,
                    IsInternal: false
                })
            );
        });
    }

    onUpdateCompanyInfo(event) {
        this.store.dispatch(
            fromCompanyInfoActions.putCompanyInfo({ JsonString: event })
        );
    }
    onUpdateAdvisor(event) {
        this.store.dispatch(
            fromCompanyInfoActions.putCompanyInfo({ JsonString: event })
        );
    }
}
